import { queryOmegaSingleResult } from "../api";
import { Volume } from "../types/volume";
export const getVolume: (config: {
  "app-id": string; "page-id": string; "block-id": string;
}) => Promise<Volume> = async (config) => {
  const appId = JSON.stringify(config["app-id"]);
  const pageId = JSON.stringify(config["page-id"]);
  const blockId = JSON.stringify(config["block-id"]);
  const query = `
        (datastore Qo.Api.Bl "omega/query-omega/api/block")
        (Qo.Api.Bl/get-data-by-id ${appId} ${pageId} ${blockId} Response)
        (return [Response])`;
  return queryOmegaSingleResult(query);
};
